import { APIResponse } from '../../../../@types/api-response';
import {
  termsAndConditionsEndpoint,
  termsAndConditionsAPI,
} from '../constants/apiEndpoint';
import {
  GetAcceptanceLetterResponse,
  GetAcceptancesLetterResponse,
  AcceptancesPayload,
} from '../types/api/termsAndConditions';
import {
  AcceptanceLanguageEnum,
  TnCFeatureIDEnum,
  TnCFeaturesIDEnum,
} from '../types/termsAndCondition';
import { exodusApiInstance } from './instance/exodus';

export const getTnCByFeature = (
  featureId: TnCFeatureIDEnum,
): Promise<APIResponse<GetAcceptanceLetterResponse>> =>
  exodusApiInstance
    .withLanguageInstance(AcceptanceLanguageEnum.BAHASA)
    .get(termsAndConditionsEndpoint.getTnCByFeature(featureId));

export const postTnCAcceptance = (
  featureId: number,
  version: number,
  isAccepted: boolean,
): Promise<APIResponse> =>
  exodusApiInstance
    .withLanguageInstance(AcceptanceLanguageEnum.BAHASA)
    .post(termsAndConditionsEndpoint.postTnCAcceptance(), {
      acceptance_letters: [
        {
          feature_id: featureId,
          is_accepted: isAccepted,
          version,
        },
      ],
    });

// terms and condition v2
export const getTnCByFeatures = (
  featureIds: TnCFeaturesIDEnum[],
): Promise<APIResponse<GetAcceptancesLetterResponse>> =>
  exodusApiInstance
    .withLanguageInstance(AcceptanceLanguageEnum.BAHASA)
    .get(termsAndConditionsAPI.getTnCByFeature(featureIds));

export const postTnCAcceptances = (
  acceptancePayload: AcceptancesPayload[],
): Promise<APIResponse> =>
  exodusApiInstance
    .withLanguageInstance(AcceptanceLanguageEnum.BAHASA)
    .post(termsAndConditionsAPI.postTnCAcceptance(), {
      acceptance_letters: acceptancePayload,
    });
